import { get } from '@/core/apis';
import { getCountryExternalApi } from '@/service/ExternalApiService';

export const LOCAL_STORAGE_REST_COUNTRIES_API = 'external-api-rest-countries';
export default class RestCountriesExternalApiService {
    setRestCountiesApiResult(data) {
        localStorage.setItem(LOCAL_STORAGE_REST_COUNTRIES_API, data);
    }

    getRestCountriesApiResult() {
        return localStorage.getItem(LOCAL_STORAGE_REST_COUNTRIES_API);
    }

    /**
     * call to external api,
     *
     */
    async callApi() {
        try {
            const response = await getCountryExternalApi()
            this.setRestCountiesApiResult(JSON.stringify(response.data));
        } catch (error) {
            console.error(error)
        }
    }

    /**
     * return from storage, if not set call api
     * @returns {Promise<string>}
     */
    async getRestCountriesApiResultFetchIfNull() {
        let item = localStorage.getItem(LOCAL_STORAGE_REST_COUNTRIES_API);
        if (item) {
            return item;
        }
        
        // call api if null
        await this.callApi();
        return localStorage.getItem(LOCAL_STORAGE_REST_COUNTRIES_API);
    }
}
